import React from "react";
import { Collapse } from "@mui/material";
import { cn } from "@helpers/utils";
import { ChevronDown } from "lucide-react";

type ConfigurationSectionProps = {
    label: string;
    children: React.ReactNode;
}

export default function ConfigurationSection({ label, children }: ConfigurationSectionProps) {
    const [isCollapsed, setIsCollapsed] = React.useState(true);

    return (
        <div
            className={cn(
                "flex flex-col border-[1px] border-solid rounded-lg transition-all overflow-hidden relative border-inputs-border-default",
            )}
        >
            <div
                className={"flex flex-row items-center justify-between space-x-2 cursor-pointer p-[16px] text-accent user-select-none"}
                onClick={() => setIsCollapsed(!isCollapsed)}
            >
                <div className={"font-semibold"}>{label}</div>
                <ChevronDown
                    className={cn("transition")}
                    style={{
                        transform: isCollapsed ? "rotate(180deg)" : undefined
                    }}
                    size={20}
                />
            </div>
            <Collapse in={isCollapsed}>
                <div className={"border-t-[1px] border-t-inputs-border-default space-y-4 p-[16px]"}
                     style={{ borderTopWidth: "1px", borderTopStyle: "solid" }}>
                    {children}
                </div>
            </Collapse>
        </div>
    );
}